import classNames from "classnames";
import React from "react";

type props = {
  children: React.ReactNode;
  variant?: "outlined" | "link" | "secondary";
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

function Button({
  children,
  className,
  fullWidth,
  variant,
  ...otherProps
}: props) {
  return (
    <button
      {...otherProps}
      className={classNames(
        "text-sm uppercase",
        fullWidth ? "w-full" : "w-auto",
        otherProps.disabled
          ? "cursor-not-allowed opacity-50"
          : "cursor-pointer",
        variant === undefined &&
          "rounded-md px-6 py-4  shadow-sm font-semibold text-white bg-wosm-default hover:bg-wosm-dark dark:hover:bg-wosm-light dark:hover:text-wosm-dark",
        variant === "outlined" &&
          "rounded-md px-6 py-4  shadow-sm font-semibold hover:bg-wosm-dark border border-wosm-default",
        variant === "secondary" &&
          "rounded-md px-6 py-4 shadow-sm font-semibold bg-gray-50 hover:bg-gray-200",
        variant === "link" && "text-wosm-default underline",
        variant === "link" && otherProps.disabled ? "text-gray-200" : "",
        className
      )}
    >
      {children}
    </button>
  );
}

export default Button;
